import progressBar from '../../../shared/DOM/progressBar.js';
import { prepareEnrollmentStep } from '../api/prepareEnrollmentStep.js';

/**
 * Enrollment show step
 *
 * @param {*} tokena
 * @param {*} user
 * @param {*} stepNum
 * @param {*} _step
 * @returns responseData
 */
export async function prepareStep(tokena, user, stepNum) {
  try {
    progressBar.loading();
    const ediwinResponse = await prepareEnrollmentStep(tokena, user, stepNum);
    if (!ediwinResponse?.result) {
      throw new Error(ediwinResponse.message || 'global.error-occurred');
    }
    progressBar.resolved();
    return ediwinResponse.output || {};
  } catch (error) {
    progressBar.rejected();
    throw error;
  }
}
